import React, { Component } from 'react';
import { Map, GoogleApiWrapper, Marker } from 'google-maps-react';

// const styles = {
//   map: {
//     width: "70%",
//     height: "70vh",
//     margin: "10px 10% 10px 10%",
//     overflowY: "scroll"
//   }
// };
// const styles = {
//   map: {
//     width: "70%",
//     height: "50vh",
//     margin: "10px 0px 10px 10%",
//     overflowY: "visible"
//   }
// };

export class MapContainer extends Component {
  constructor(props) {
    super(props);

    //const {lat, lng} = this.props.initialCenter;
    this.state = {
      currentLocation: {
        lat: 50.2884,
        lng: 11.8233
      }
    }
  }
  componentDidMount() {
    navigator.geolocation.getCurrentPosition(res => {
      const coords = res.coords;
      this.setState({
        currentLocation: {
          lat: coords.latitude,
          lng: coords.longitude
        }
      });
    })
  }

  render() {
    //console.log("mapcontainer props:", this.props);
    return (
      <Map
        google={this.props.google}
        zoom={4}
        style={this.props.map}
        initialCenter={{
         lat: 50.2884,
         lng: 11.8233
        }}
      >
        <Marker position={this.state.currentLocation} />
        <Marker position={{lat: this.props.lat, lng: this.props.lng}} />
      </Map>
    );
  }
}

export default GoogleApiWrapper({
  apiKey: 'AIzaSyD2eK5LTngWgTTvyt17ijwNYTzwoGfhk6Q'
})(MapContainer);